import * as type from '../constants/ActionTypes';

export default function products(
  state = {},
  action
) {
  switch (action.type) {
    case type.PRODUCT_LIST_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      });
    case type.PRODUCT_LIST_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        productList: action.response
      });
    case type.PRODUCT_LIST_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      });
    default:
      return state;
  }
}
